import { FaBoxOpen, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaUsers, FaWhatsapp, FaWifi } from "react-icons/fa6";

export const NavLinkItemAbo = [
  { name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  {
    name: "Master Data", icon: FaDatabase, type: "accordion",
    subItems: [
      { name: "NAS / Mikrotik", path: "/dashboard/master-data/nas" },
      { name: "OLT", path: "/dashboard/master-data/olt" },
      { name: "POP", path: "/dashboard/master-data/pop" },
      { name: "ODC", path: "/dashboard/master-data/odc" },
      { name: "ODP", path: "/dashboard/master-data/odp" },
      { name: "Mapping", path: "/dashboard/master-data/mapping" },
    ],
  },
  {
    name: "PPPoE", icon: FaWifi, type: "accordion",
    subItems: [
      { name: "Profile", path: "/dashboard/pppoe/profile" },
      { name: "User", path: "/dashboard/pppoe/user" },
      { name: "PSB", path: "/dashboard/pppoe/psb" },
    ],
  },

  {
    name: "Invoice", icon: FaBoxOpen, type: "accordion",
    subItems: [
      { name: "List", path: "/dashboard/invoice/list" },
      { name: "Janji Bayar", path: "/dashboard/invoice/promise-to-pay" },
    ],
  },
  {
    name: "WhatsApp", icon: FaWhatsapp, type: "accordion",
    subItems: [
      { name: "Pesan Wa", path: "/dashboard/whatsapp/message" },
      { name: "No Whatsapp", path: "/dashboard/whatsapp/number" },
      { name: "Template Pesan", path: "/dashboard/whatsapp/template" },
    ],
  },
  // { name: "WhatsApp", icon: FaWhatsapp, path: "/dashboard/whatsapp", type: "link" },
  { name: "Tiket Gangguan", icon: FaLifeRing, path: "/dashboard/ticket", type: "link" },
  { name: "Keuangan", icon: FaMoneyBillWave, path: "/dashboard/finance", type: "link" },
  { name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },
];